// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";  // ✅ add this line

// import { getAnalytics } from "firebase/analytics"; // Comment out if not used
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCSyTkV0kPUUoC3HttFgpPUQL8z7ZBfzc0",
  authDomain: "product-manager-8577c.firebaseapp.com",
  projectId: "product-manager-8577c",
  storageBucket: "product-manager-8577c.appspot.com",
  messagingSenderId: "328963935942",
  appId: "1:328963935942:web:4d085b44c6b8e5dfb3d1c7",
  measurementId: "G-LGHJ55TZ9X"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
export { app };
export const db = getFirestore(app);
